const RefreshIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.74996 15.4999C5.58643 15.4999 3.75389 14.7491 2.25233 13.2476C0.750777 11.746 0 9.91349 0 7.74996C0 5.58643 0.750777 3.75389 2.25233 2.25233C3.75389 0.750777 5.58643 0 7.74996 0C8.86402 0 9.92964 0.230077 10.9468 0.690231C11.964 1.15038 12.8359 1.80832 13.5624 2.66405V0H15.4999V6.78121H8.7187V4.84372H12.7874C12.2708 3.93956 11.5644 3.22915 10.6683 2.71249C9.77221 2.19582 8.79943 1.93749 7.74996 1.93749C6.13538 1.93749 4.763 2.50259 3.63279 3.63279C2.50259 4.763 1.93749 6.13538 1.93749 7.74996C1.93749 9.36453 2.50259 10.7369 3.63279 11.8671C4.763 12.9973 6.13538 13.5624 7.74996 13.5624C8.99318 13.5624 10.1153 13.2072 11.1163 12.4968C12.1174 11.7864 12.8197 10.8499 13.2234 9.68745H15.2577C14.8057 11.3989 13.8853 12.7955 12.4968 13.8773C11.1083 14.959 9.52599 15.4999 7.74996 15.4999Z"
      fill="white"
    />
  </svg>
);

export default RefreshIcon;
